import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { StatistikTilafgangKunde } from './StatistikTilafgangKunde';
import { IndexCard, User } from 'app/auth/store/models';
import { firstDayThisMonth, lastDayThisMonth } from '../../../shared/month-picker/month-picker.helper';


@Component({
    selector: 'app-statistik-tilafgang-ui',
    templateUrl: './statistik-tilafgang.component.html',
    styleUrl: './statistik-tilafgang.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikTilafgangComponent implements OnInit {

    @Input() laCards: IndexCard[];
    @Input() kaCards: IndexCard[];
    @Input() saCards: IndexCard[];
    @Input() user: User | undefined;
    @Input() laID: number;
    @Input() kaID: number;
    @Input() saID: number;
    @Input() nyeKunder: StatistikTilafgangKunde[];
    @Input() mistedeKunder: StatistikTilafgangKunde[];
    @Input() periode: { fra: string, til: string };
    @Output() periodeChange = new EventEmitter<{ fra: string, til: string }>();
    @Output() laChange = new EventEmitter<number>();
    @Output() kaChange = new EventEmitter<number>();
    @Output() saChange = new EventEmitter<number>();

    get totalNyForventetOms() {
        return this.filterByLaKaSa(this.nyeKunder).reduce((acc, kunde) => acc + kunde.forventoms, 0);
    }

    get totalMistetOms() {
        return this.filterByLaKaSa(this.mistedeKunder).reduce((acc, kunde) => acc + kunde.oms, 0);
    }

    ngOnInit(): void {
        const newPeriode = {
            fra: firstDayThisMonth(),
            til: lastDayThisMonth()
        };
        this.onPeriodeChange(newPeriode);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.user && this.user) {
            const iCard = this.user.indexCard;
            if (iCard.ledelsesansvarlig) {
                this.onLedelseAnsvarligSelected(iCard.cardId);
            }
            if (iCard.kundeansvarlig && !iCard.ledelsesansvarlig) {
                this.onKundeAnsvarligSelected(iCard.cardId);
            }
            if (iCard.sagsbehandler && !iCard.kundeansvarlig && !iCard.ledelsesansvarlig) {
                this.onSagsAnsvarligeSelected(iCard.cardId);
            }
        }
    }

    onPeriodeChange(periode: { fra: string; til: string }) {
        this.nyeKunder = [];
        this.mistedeKunder = [];
        this.periodeChange.emit(periode);
    }

    onLedelseAnsvarligSelected($event: number) {
        this.laChange.emit($event);
    }

    onKundeAnsvarligSelected($event: number) {
        this.kaChange.emit($event);
    }

    onSagsAnsvarligeSelected($event: number) {
        this.saChange.emit($event);
    }

    findLaName(id: number): string {
       return this.laCards.find(c => c.cardId === id)?.brugerId;
    }

    findKaName(id: number): string {
        return this.kaCards.find(c => c.cardId === id)?.brugerId;
    }

    getErhvervselskabmedel(bool: boolean): string {
        let erhvervselskabmedel = 'nej';
        if (bool) { erhvervselskabmedel = 'ja'; }
        return erhvervselskabmedel;
    }

    getDateString(date: Date): string {
        let dateString = '';
        if (date != null) { dateString = date.toString().substring(0, 10); }
        return dateString;
    }

    getColorCode(colorCode: number): string {
        let colorString: string;
        if (colorCode === 0) { colorString = 'blue'; }
        if (colorCode === 1) { colorString = 'green'; }
        if (colorCode === 2) { colorString = 'red'; }
        if (colorCode === 3) { colorString = 'black'; }
        if (colorCode !== 1 && colorCode !== 2 && colorCode !== 3 && colorCode !== 0) { colorString = 'grey'; }
        return colorString;
    }

    filterByLaKaSa(array: StatistikTilafgangKunde[]): StatistikTilafgangKunde[] {
        if (!array) {
            return [];
        }

        return array.filter(kunde => {
            const laMatch = this.laID ? kunde.ledelsesansvarlig === this.laID : true;
            const kaMatch = this.kaID ? kunde.kundeansvarlig === this.kaID : true;
            const saMatch = this.saID ?
                (kunde.sagsansvarlig && kunde.sagsansvarlig.length > 0 &&
                 kunde.sagsansvarlig.some(sa => sa === this.saID)) : true;

            return laMatch && kaMatch && saMatch;
        });
    }
}
